import {DynamicDatagrid, MuiDataGrid, Paper} from "@leap4/frontend";
import * as React from "react";
import {EntitiesProperties} from "../../../../../utils/enums";
import {TableCellType} from "../../../../shared/TableCellWithComparison/TableCellWithCompare";
import {useContext, useEffect, useState} from "react";
import {UserViewsContext} from "../../../../../contexts/userViewsContext";
import {generateColumn} from "../../../common/tableColumnsGenerator";
type GridColDef = MuiDataGrid.GridColDef;

export interface IHomePartnersTableProps {
    partners: Array<any>,
    isLoading: boolean
    compareData: Array<any>
}

export default function HomeTopPartnersComboTable(props: IHomePartnersTableProps): JSX.Element {
    const {partners, isLoading, compareData} = props;
    const {userViews} = useContext(UserViewsContext)
    const [columns, setColumns] = useState<GridColDef[]>([])
    const { DEMAND_PARTNER, SUPPLY_PARTNER } = EntitiesProperties.NOT_NUMERIC

    useEffect(()=>{
        const userPresetColumns = userViews.activePreset.tableViews.map(view => generateColumn(view, compareData, TableCellType.PartnersComboTable))
        const preConstantColumns = [SUPPLY_PARTNER, DEMAND_PARTNER].map(view => generateColumn(view, compareData))
        setColumns([...preConstantColumns,...userPresetColumns])
    },[userViews, compareData])

    function createRowData(item: any) {
        const {totals} = item;
        const profit = totals?.revenue - totals?.cost;
        if (!item.supplyPartner || !item.demandPartner) {
            return null
        }
        return {
            id: item.demandPartner + item.supplyPartner,
            supplyPartner: item.supplyPartnerName,
            demandPartner: item.demandPartnerName,
            profit: totals.profit,
            completion: totals.completion,
            vcr: totals?.impressions === 0 ? 0 : totals.completion / totals.impressions * 100,
            profitPercent: (profit / totals?.revenue) * 100,
            fillRate: ((totals?.impressions || 0) / (totals?.requests)) * 100,
            cpm: totals?.impressions === 0 ? 0 : totals?.cost / totals?.impressions * 1000,
            rpm: totals?.impressions === 0 ? 0 : totals?.revenue / totals?.impressions * 1000,
            ...totals
        }
    }
    const rows = partners.map((partner,) =>
        createRowData(partner)
    ).filter(x => !!x).sort((a, b) => b.impressions > a.impressions ? 1 : -1);

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: 'none'}} elevation={5}>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={isLoading}
                             refreshFunc={() => {
                             }}
                             loadError={false}
                             pageSize={25}
                             style={{minHeight: `75vh`, width: '100%'}}
            />
        </Paper>
    );
}
